import { TextKey } from '@mews-commander/enums';
import { LocalizedNumber, LocalizedText } from '@mews/framework';
import { RoutingRuleOrderItemConsumptionPeriodType } from '@mews-commander/data-access';

export const consumptionDateOptions = [
    {
        key: RoutingRuleOrderItemConsumptionPeriodType.MonthBefore,
        value: RoutingRuleOrderItemConsumptionPeriodType.MonthBefore,
        primaryText: TextKey.RoutingRulesFormConsumptionDateLabelPreviousMonth,
        secondaryText: TextKey.RoutingRulesFormConsumptionDateDescriptionPreviousMonth,
    },
    {
        key: RoutingRuleOrderItemConsumptionPeriodType.SameMonthAndMonthBefore,
        value: RoutingRuleOrderItemConsumptionPeriodType.SameMonthAndMonthBefore,
        primaryText: TextKey.RoutingRulesFormConsumptionDateLabelPreviousAndCurrentMonth,
        secondaryText: TextKey.RoutingRulesFormConsumptionDateDescriptionPreviousAndCurrentMonth,
    },
    {
        key: RoutingRuleOrderItemConsumptionPeriodType.SameMonth,
        value: RoutingRuleOrderItemConsumptionPeriodType.SameMonth,
        primaryText: TextKey.RoutingRulesFormConsumptionDateLabelSameMonth,
        secondaryText: TextKey.RoutingRulesFormConsumptionDateDescriptionSameMonth,
    },
    {
        key: RoutingRuleOrderItemConsumptionPeriodType.SameMonthAndMonthAfter,
        value: RoutingRuleOrderItemConsumptionPeriodType.SameMonthAndMonthAfter,
        primaryText: TextKey.RoutingRulesFormConsumptionDateLabelCurrentAndFollowingMonth,
        secondaryText: TextKey.RoutingRulesFormConsumptionDateDescriptionCurrentAndFollowingMonth,
    },
    {
        key: RoutingRuleOrderItemConsumptionPeriodType.MonthAfter,
        value: RoutingRuleOrderItemConsumptionPeriodType.MonthAfter,
        primaryText: TextKey.RoutingRulesFormConsumptionDateLabelFollowingMonth,
        secondaryText: TextKey.RoutingRulesFormConsumptionDateDescriptionFollowingMonth,
    },
];

export const dayOfMonthOptions = [
    ...Array.from({ length: 28 }, (_, index) => ({
        key: index + 1,
        value: index + 1,
        primaryText: <LocalizedNumber number={index + 1} />,
    })),
    ...[29, 30, 31].map((day) => ({
        key: day,
        value: day,
        primaryText: <LocalizedText textKey={TextKey.RoutingRulesFormDayOfMonthOption} substitutes={{ day }} />,
    })),
];
